<style lang="scss" scoped>
@import '@/view/qwAuth/index.scss';
.center {
  width: 888px;
  height: 426px;
  background: #ffffff;
  border-radius: 2px;
  position: relative;
  text-align: center;
  margin: 0 auto;
  padding-top: 70px;
}
.title {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1890ff;
  line-height: 28px;
}
.box {
  width: 68px;
  height: 4px;
  background: linear-gradient(90deg, #f0f0f1 0%, #c4c4c4 54%, #e6e7e7 100%);
}
.icons {
  display: flex;
  justify-content: space-between;
  padding: 0 277px;
  margin-top: 44px;
  padding-top: 7px;

  .left36 {
    position: relative;
    left: 36px;
  }

  .btn {
    width: 200px;
    height: 40px;
    margin-right: 28px;
    border-radius: 2px;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 200px;
      height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2083e0;
      line-height: 40px;
    }
  }
  .btn_login {
    border-radius: 2px;
    border: 1px solid #2083e0;
  }
  .icon {
    width: 63px;
    height: 63px;
    margin-bottom: 22px;
    .icon_img {
      width: 100%;
      height: auto;
    }
  }
  .text {
    height: 20px;
    width: 100px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #444444;
    line-height: 20px;
    img {
      width: 68px;
      height: 4px;
      position: relative;
      top: -3px;
      left: 7px;
    }
  }
}
</style>
<template>
  <div style="padding-top: 136px">
    <div class="center">
      <div
        class="toLogin"
        @click="$router.push({ path: '/qwAuth/register' })"
      >
        还没有账号 <span class="toLogin_btn">立即注册</span>
      </div>
      <div class="title">
        云店营销中心登录
      </div>
      <div class="icons">
        <div>
          <img
            class="icon"
            :src="require('@/assets/img/qwLogin/hk2.png')"
            alt=""
          >
          <div class="text left36">
            <span>获客</span>
            <img
              class="icon_img"
              :src="require('@/assets/img/qwLogin/stop.png')"
              alt=""
            >
          </div>
        </div>
        <div>
          <img
            class="icon"
            :src="require('@/assets/img/qwLogin/zh2.png')"
            alt=""
          >
          <div class="text left36">
            <span>转化</span>
            <img
              class="icon_img"
              :src="require('@/assets/img/qwLogin/stop.png')"
              alt=""
            >
          </div>
        </div>
        <div>
          <img
            class="icon"
            :src="require('@/assets/img/qwLogin/lb2.png')"
            alt=""
          >
          <div class="text">
            <span>裂变</span>
          </div>
        </div>
      </div>
      <div
        class="icons"
        style="padding: 0; justify-content: center; margin-top: 79px"
      >
        <a :href="QWLoginUrl">
          <div class="btn">
            <img
              :src="require('@/assets/img/qwLogin/qwImg/login_blue_middle.png')"
              alt=""
            >
          </div>
        </a>
        <!-- <div class='btn btn_login'>
          账号密码登录
        </div> -->
        <!-- <el-button
          type="primary"
          class="btn"
          @click="QWSign"
        >
          注册企业微信
        </el-button> -->
        <el-button
          type="primary"
          plain
          class="btn"
          style="margin-right: 0; border: 1px solid #2083e0; background-color: #fff; color: #2083e0"
          @click="QWSign('user')"
        >
          账号密码登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { QWLogin } from '@/api/qwAuth'
export default {
  components: {},
  data () {
    return {
      QWLoginUrl: ''
    }
  },
  watch: {},
  created () {
    this.getQWLoginUrl()
  },
  mounted () {},
  methods: {
    callFun () {},
    //企微登录接口
    QWSign (type) {
      if (type == 'user') return this.$router.push({ path: '/auth/login' })
      location.href = this.QWLoginUrl
      // window.open(
      //   `${this.QWLoginUrl}?appid=ww21a77804a566228f&redirect_uri=http://salesperson.ex-sandbox.com/qwAuth/bindPhone&state=qwWeb_login`
      // )
    },
    //获取企微登录接口
    getQWLoginUrl () {
      QWLogin({
        channel_source: '1',
        redirect_uri: `${location.origin}/qwAuth/bindPhone`
      }).then((res) => {
        this.QWLoginUrl = res.url
      })
    }
  }
}
</script>
